import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterModule} from "@angular/router";
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {LoginServerService} from "../public/login/services/login-server.service";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {ErrorCodeService} from "../../shared/services/error-code.service";
import {RouteTrackerService} from "../../shared/services/route-tracker.service";
import {ErrorCode} from "../../shared/models/ErrorCode";
import {ZendeskHelpComponent} from "../../shared/components/zendesk-help/zendesk-help.component";
import {CommonModule} from "@angular/common";
import {LoginFooterComponent} from "../public/login/login-footer/login-footer.component";

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    imports: [
        CommonModule,
        LoginFooterComponent,
        RouterModule
    ]
})
export class ErrorComponent implements OnInit {
  constructor(private _router: Router, private _route: ActivatedRoute, private _loginService: LoginServerService, 
              private _modalService: NgbModal, private _errorCodeService: ErrorCodeService,
              private _routeTracker: RouteTrackerService) {
  }
  
  @Input()
  public errorCode: number = 0;
  public errorDetails: ErrorCode;
  public isLoading = true;
  
  async ngOnInit() {
    if (this._errorCodeService.errorCode) {
      this.errorCode = this._errorCodeService.errorCode;
      this.errorDetails = await firstValueFrom(this._loginService.getErrorDetails(this.errorCode));
      if (!this.errorDetails || !this.errorDetails.code) {
        this.goHome();
      }
    } else {
      var errorCode = this._route.snapshot.paramMap.get("code");
      if (errorCode) {
        this.errorCode = parseInt(errorCode);
        this.errorDetails = await firstValueFrom(this._loginService.getErrorDetails(this.errorCode));
        if (!this.errorDetails || !this.errorDetails.code) {
          this.goHome();
        }
      } else {
        this.goHome();
      }
    }
    this.isLoading = false;
  }
  
  public get isLoggedIn() {
    return this._loginService.userToken && this._loginService.userToken.unique_name;
  }
  
  public goHome() {
    this._router.navigate(["/"]);
    //this._errorCodeService.showError = 0;
  }
  
  openHelp() {
    let ngbModalOptions: NgbModalOptions = {
      windowClass: "modal-custom"
    };
    var ref = this._modalService.open(ZendeskHelpComponent, ngbModalOptions);
    var component = ref.componentInstance as ZendeskHelpComponent;
    component.errorCode = this.errorCode;
    var prevRoute = this._routeTracker.previousRoute;
    if (prevRoute) {
      component.previousRoute = prevRoute.split('?')[0];
    } else {
      component.previousRoute = "Direct";
    }
  }
  
  public async logOut() {
    await this._loginService.accountLogoutSelected(false);
   this.goHome();
  }
}
